import type { Bloco, BlocoKanbanColumn, BlocoKanbanColumnKind } from '@/types/bloco'

export const DEFAULT_KANBAN_COLUMN_COLORS = ['#94a3b8', '#3b82f6', '#14b8a6', '#ec4899', '#8b5cf6', '#f59e0b', '#22c55e']

export const DEFAULT_LABEL_COLORS = DEFAULT_KANBAN_COLUMN_COLORS

function findColumnByKind(columns: BlocoKanbanColumn[], kind: BlocoKanbanColumnKind) {
  return [...columns].sort((a, b) => a.sortOrder - b.sortOrder).find((c) => c.kind === kind)
}

export function resolveBlocoDisplayColumnId(
  bloco: Pick<Bloco, 'userId' | 'kanbanColumnId' | 'kanbanColumn' | 'status' | 'pendingUserId'>,
  viewerId: string | undefined,
  viewerColumns: BlocoKanbanColumn[],
): string {
  if (bloco.status === 'done') {
    return findColumnByKind(viewerColumns, 'done')?.id ?? bloco.kanbanColumnId
  }

  const ownerKind = bloco.kanbanColumn?.kind ?? 'open'

  if (bloco.userId === viewerId) {
    if (bloco.pendingUserId && ownerKind !== 'waiting') {
      return findColumnByKind(viewerColumns, 'waiting')?.id ?? bloco.kanbanColumnId
    }
    return bloco.kanbanColumnId
  }

  if (bloco.pendingUserId) {
    return findColumnByKind(viewerColumns, 'waiting')?.id ?? bloco.kanbanColumnId
  }

  return findColumnByKind(viewerColumns, ownerKind)?.id ?? bloco.kanbanColumnId
}

export function getInitialKanbanColumnId(columns: BlocoKanbanColumn[]): string | undefined {
  return findColumnByKind(columns, 'open')?.id ?? columns[0]?.id
}
